import config from 'config';

const initalState = {
    placeholderTimeStamp: config.atrVideo.placeholderTimestamp
};

export default function reducer(state = initalState, action = {}) {
    return state;
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/atrVideo.js